import type { LinkProps } from '@mui/material/Link'
import Link from '@mui/material/Link'

import { NavLinkBehavior } from './NavLinkBehavior'

export type NavLinkPorps = LinkProps

/**
 * NavLink
 */
export function NavLink(props: NavLinkPorps) {
  return <Link {...props} component={NavLinkBehavior} />
}
